module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('site-header', [_c('h1', [_vm._v("Commercials")])]), _vm._v(" "), _c('main', {
    staticClass: "wrap",
    class: _vm.$style.commercials
  }, [(!this.loading) ? _c('p', {
    class: _vm.$style.lede
  }, [_vm._v("I have carried out sound design duties on numerous commercials and promos. Some of the brands I've worked with are shown below.")]) : _vm._e(), _vm._v(" "), _c('article', {
    class: _vm.$style.logos
  }, _vm._l((_vm.brands), function(item) {
    return _c('div', [_c('img', {
      attrs: {
        "src": item.acf.logo.sizes.large
      }
    })])
  }), 0)]), _vm._v(" "), (this.loading) ? _c('loader') : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7a840429!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Commercials.vue
// module id = 116
// module chunks = 2